import { render, staticRenderFns } from "./VE_Vars.vue?vue&type=template&id=8be40cbe&scoped=true&"
import script from "./VE_Vars.vue?vue&type=script&lang=js&"
export * from "./VE_Vars.vue?vue&type=script&lang=js&"
import style0 from "./VE_Vars.vue?vue&type=style&index=0&id=8be40cbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be40cbe",
  null
  
)

export default component.exports